import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { Constrainable } from '@morningtrain/react-filters'
import PeriodFilter from './PeriodFilter'
import moment from 'moment'
import UpdateCookieOnChange from "support/utilities/UpdateCookieOnChange";
import {useCookies} from "react-cookie";

export default function PeriodFilterSyncedWithPage (props) {
  const cookieName = props.cookieName ? props.cookieName : 'page.filters.period';
  const [cookies] = useCookies([cookieName]);

  let defaultPeriod = {
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD')
  }

  if (cookies[cookieName] !== undefined) {
    defaultPeriod = cookies[cookieName];
  }

  return (
    <Constrainable>
      <UpdateCookieOnChange name={cookieName}>
        <PeriodFilter
          name='period'
          withSelectors
          defaultValue={defaultPeriod}
          {...props}
        />
      </UpdateCookieOnChange>
    </Constrainable>
  )
}
